/**
 * Show a frame's card on this window's wall: scroll it into view and flash
 * it, or give it keyboard focus when focus over the wall closes. The mounted
 * `WallView` registers the handler; without a wall nothing happens.
 */

export interface WallRevealOptions {
  /** Give the card keyboard focus instead of flashing it. */
  focus?: boolean;
}

type WallRevealer = (frameId: string, options: WallRevealOptions) => void;

let revealer: WallRevealer | null = null;

export function revealWallCard(
  frameId: string,
  options: WallRevealOptions = {},
): void {
  revealer?.(frameId, options);
}

/** Register this window's wall; returns the unregister. */
export function registerWallRevealer(next: WallRevealer): () => void {
  revealer = next;
  return () => {
    if (revealer === next) revealer = null;
  };
}
